<script lang="ts">
	import HDPlayoffEncounter from './HDPlayoffEncounter.svelte';
	import Placeholder from '#lib/components/Placeholder.svelte';
	import { getKnockoutStage } from '../hockeydata.remote.js';

	let { divisionId }: { divisionId: string } = $props();

	const knockoutStageData = $derived.by(() => {
		if (!divisionId) {
			return Promise.reject('No divisionId provided');
		}
		return getKnockoutStage(divisionId);
	});
</script>

{#await knockoutStageData}
	<Placeholder text="Playoffs werden geladen" />
{:then dataResponse}
	{@const data = dataResponse.data}
	<div class="flex w-full flex-col justify-between gap-3 md:flex-row">
		{#each data.phases as phase (phase.divisionName)}
			<div class="flex w-full flex-col items-center justify-center gap-3">
				<h3>{phase.divisionName}</h3>
				{#each phase.encounters as encounter (encounter.longname)}
					<div class="flex w-full grow items-center justify-center">
						<HDPlayoffEncounter {encounter} {divisionId} />
					</div>
				{/each}
			</div>
		{/each}
	</div>
{:catch error}
	<div class="w-full text-center text-red-500">
		<p>Error loading data: {error.message}</p>
	</div>
{/await}
